class AddOns {
  constructor() {
  }

  static factory($resource, $log, config) {
    return $resource(
      config.plansResourcePath + '/:plan' + '/add-ons', {}, {
        get: {
          method: 'GET',
          params: { plan: '@plan' }
        }
      }
    )
  }
}

AddOns.factory.$inject = ['$resource', '$log', 'config']

export default AddOns
